module.exports = __webpack_public_path__ + "img/emptybag.9fffec98.png";